import {cloneDeep} from "lodash";
import {getString, resetObjectValues} from "Core/helpers/data";
import {OfficeLocationItemDataObject} from "../dataObjects";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {OfficeLocationItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new OfficeLocationItemDataObject(
		getString(result, 'uniqueID'),
		getString(result, 'name'),
		getString(result, 'address'),
		getString(result, 'phone'),
		getString(result, 'mobilePhone')
	);

	return result;
}

/**
 * Get output data from input data
 * @param {OfficeLocationItemDataObject} inputData - Input data.
 * @return {Object}
 */
export const output = inputData => {
	let result = cloneDeep(inputData);

	result = {
		uniqueID: result.id,
		name: result.locationName,
		address: result.locationAddress,
		phone: result.locationPhone,
		mobilePhone: result.locationMobile,
	};

	// Set proper empty values expected by the API
	result = resetObjectValues(result);

	return result;
}